import { DOCUMENT_SETSTATE } from "./WeddingActionType";

const apiConfig = window as any;

const initialState = {
    startv: false,
    indexV: 1,
    intImage:apiConfig.INIT_MARRIAGE_IMAGE_COUNTER
};

export function WeddingReducer(state = initialState, action: any) {
    switch (action.type) {
        case DOCUMENT_SETSTATE:
            return { ...state, [action.payload.key]: action.payload.value };
        default:
            return state;
    }
}
